import { render, staticRenderFns } from "./Farms.vue?vue&type=template&id=a4042fb2&lang=html&"
import script from "./Farms.vue?vue&type=script&lang=js&"
export * from "./Farms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports